<div  [ngClass]="data?.theme == 'dark' ? 'dark-mode' : ''">
    <mat-dialog-content [ngClass]="data?.theme == 'dark' ? 'dark-bg p-4' : 'p-4'">
        <div class="d-flex justify-content-between">
            <h3 style="font-size: 22px;" [ngClass]="data?.theme == 'dark' ? 'text-white' : ''">{{ data.title ? data.title : 'Information' }}</h3>
            <button mat-icon-button (click)="closeDialog()" [ngClass]="data?.theme == 'dark' ? 'text-white' : ''">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="mt-5" *ngIf="data?.message && data?.message != ''" [ngClass]="data?.theme == 'dark' ? 'text-white' : ''">
            {{data?.message}}
        </div>
        <div  [ngClass]="data?.theme == 'dark' ? 'text-grey' : ''">{{data?.subMessage}}</div>
    </mat-dialog-content>
</div>
<div  [ngClass]="data?.theme == 'dark' ? 'dark-mode' : ''">
<mat-dialog-actions [ngClass]="data?.theme == 'dark' ? 'dark-bg p-4 justify-content-end' : 'p-4 justify-content-end'">
    <button mat-raised-button [ngClass]="data?.theme == 'dark' ? 'dark-theme-btn':'light-theme-btn'" (click)="ok()">OK</button>
</mat-dialog-actions>
</div>
